import React from "react";
import { IComponentAccessProps } from "../../types/componentTypes/componentAccessTypes";
import { useUser } from "../../providers/UserContext";
import { NotAuthorizedPage } from "../../pages/NotAuthorizedPage/NotAuthorizedPage";

/**
 * Determines whether the user's role is included in the provided list of roles.
 *
 * @param userRole - The user's role (or highest role level)
 * @param includedRoles - List of roles to check against
 * @returns True if the user's role is included, otherwise false
 */
const isUserRoleExcluded = (
    userMaxRole: number,
    excludeRoles: number[]
): boolean => {
    if (excludeRoles.length === 0) {
        return false;
    }

    return excludeRoles.includes(userMaxRole);
};

// Show the component only if the user has the sufficent permission
export function ComponentAccess({ children, minRole, useRejectComp = false, excludeRoles=[]}: IComponentAccessProps) {
    const { userMaxRole } = useUser();

    const hasSufficientRole = userMaxRole <= minRole;
    const isUserRoleAllowed = !isUserRoleExcluded(userMaxRole, excludeRoles);

    return (
        hasSufficientRole && isUserRoleAllowed
            ? React.Children.only(children) : useRejectComp
                ? <NotAuthorizedPage /> : null
    )
}
